<template>
  <base-dialog
    data-testid="chatTermsOfUseDialog.dialog"
    max-width="600"
    title="AI Copilot - Terms of Use"
    dialog-id="chatTermsOfUseDialog"
    @complete-dialog="onAccept"
    @cancel-dialog="onCancel"
  >
    <template #content>
      <!--TODO: text wich explains the usage context and proposed best practices #845 -->
      <div>
        Be aware that the copilot uses 3rd party LLM services (Open AI). So you need to accept the terms of use first
        before you can use the copilot.
      </div>
      <div class="mt-4">
        Furthermore here are some tips how to use the copilot:
        <ol class="ml-9 mt-2">
          <li>Describe a state machine and ask to create it for you.</li>
        </ol>
      </div>
    </template>
    <template #footer>
      <v-btn-dialog-action data-testid="chatTermsOfUseDialog.cancel-button" @click="onCancel">
        Decline
      </v-btn-dialog-action>
      <v-btn-dialog-action-CTA data-testid="chatTermsOfUseDialog.accept-button" @click="onAccept">
        Accept to continue</v-btn-dialog-action-CTA
      >
    </template>
  </base-dialog>
</template>

<script setup lang="ts">
import { inject } from "vue";
import BaseDialog from "../../shared/BaseDialog.vue";
import LocalStorage from "../services/persistance/local-storage";

const emit = defineEmits(["cancel", "accept"]);

const localStorage: LocalStorage = inject<LocalStorage>("localStorage");

function onCancel() {
  emit("cancel");
}

async function onAccept() {
  localStorage.set("acceptedAI", "true");
  emit("accept");
}
</script>
